import removeImageCommand from './remove-image';

export {removeImageCommand};
